import { useMutation, useQuery } from '@tanstack/react-query'

import { scenarioComparisonClient } from '@/api'
import { downloadFromBlob } from '@/utils'

export const useScenarioComparison = (scenarioIds: number[]) => {
  const BASE_QUERY_KEY = [
    ...scenarioComparisonClient.QUERY_KEY,
    { scenarioIds }
  ]

  const getScenarioComparisonQuery = useQuery({
    queryKey: BASE_QUERY_KEY,
    queryFn: () => scenarioComparisonClient.getScenarioComparison(scenarioIds)
  })

  const getScenarioComparisonAnnuallyQuery = useQuery({
    queryKey: [...BASE_QUERY_KEY, 'annual'],
    queryFn: () =>
      scenarioComparisonClient.getScenarioAnnualComparison(scenarioIds)
  })

  const downloadComparisonMutation = useMutation({
    mutationFn: () =>
      scenarioComparisonClient.downloadScenarioComparisonReport(scenarioIds),
    onSuccess: result =>
      downloadFromBlob(`ComparisonExport_${scenarioIds.join('_')}.xlsx`, result)
  })

  return {
    comparisonInfo: getScenarioComparisonQuery.data || [],
    isFetching: getScenarioComparisonQuery.isFetching,
    isError:
      getScenarioComparisonQuery.isError ||
      getScenarioComparisonAnnuallyQuery.isError,
    detailedComparisonInfo: getScenarioComparisonAnnuallyQuery.data || [],
    downloadComparison: downloadComparisonMutation.mutate,
    isDownloadComparisonInProgress: downloadComparisonMutation.isPending
  }
}
